import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React from 'react';

import { Select } from '~/components/blocks';
import { HOUR_OPTIONS, MINUTE_OPTIONS } from '~/constants/organization_business_hour';
import { getAvailableMinutes } from '~/utils/time';

const SmallSelect = styled(Select)(({ theme }) =>
  css({
    fontSize: theme.fontSizes.m,
    minWidth: '55px',
    height: '44px',
    marginLeft: 0,
    '& + &': {
      marginLeft: theme.space.xs,
    },
  }),
);

type Props = {
  disabled: boolean;
  hour: string;
  minute: string;
  onHourChange: (hour: string) => void;
  onMinuteChange: (minute: string) => void;
};

export const TimeSelect = (props: Props) => {
  const { disabled, hour, minute, onHourChange, onMinuteChange } = props;
  const minuteOptions = getAvailableMinutes(hour, MINUTE_OPTIONS);

  return (
    <>
      <SmallSelect disabled={disabled} value={hour} onChange={(e) => onHourChange(e.target.value)}>
        {HOUR_OPTIONS.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </SmallSelect>
      <SmallSelect
        disabled={disabled}
        value={minute}
        onChange={(e) => onMinuteChange(e.target.value)}
      >
        {minuteOptions.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </SmallSelect>
    </>
  );
};
